var defaultStateKey = 'EXACTA_APP_STATE';
export var loadState = function (stateKey) {
    if (stateKey === void 0) { stateKey = defaultStateKey; }
    try {
        var serializedState = localStorage.getItem(stateKey);
        if (serializedState === null) {
            return undefined;
        }
        return JSON.parse(serializedState);
    }
    catch (err) {
        return undefined;
    }
};
export var saveState = function (state, stateKey) {
    if (stateKey === void 0) { stateKey = defaultStateKey; }
    try {
        var serializedState = JSON.stringify(state);
        localStorage.setItem(stateKey, serializedState);
    }
    catch (err) {
        console.error('Error in saving state!');
    }
};
export var getSavedState = function (state, keys) {
    if (Array.isArray(keys) && keys.length > 0) {
        return Object.keys(state).reduce(function (savedState, key) {
            if (keys.indexOf(key) >= 0) {
                savedState[key] = state[key];
            }
            return savedState;
        }, {});
    }
    return state;
};
//# sourceMappingURL=index.js.map